// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3qtZV","messages":"Chat_messages__2cQGu","dateDivider":"Chat_dateDivider__3uIao"};